export var VisitableType;
(function (VisitableType) {
    VisitableType["INSPECTION"] = "Inspection";
    VisitableType["SERVICE"] = "WorkOrder";
})(VisitableType || (VisitableType = {}));
